import(/* webpackMode: "eager" */ "/codebuild/output/src4255266600/src/apps/fanychance/src/app/error.tsx");
